import { Injectable } from '@angular/core';
import { User } from '@entities/user.entity';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class UserStore {
    user: User = {
        azureId: '',
        email: '',
        name: '',
        token: '',
        isAdmin: false,
        isGuest: false,
        _language: 'de',
    };

    constructor(private translate: TranslateService) {
        const user = localStorage.getItem('user');
        if (user) {
            console.log('User found in local storage -> reusing');
            this.updateUser({ ...new User(), ...JSON.parse(user) } as User);
        }

        this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
            this.user._language = event.lang;
            this.updateUser(this.user);
        });
    }

    getUser(): User {
        return this.user;
    }

    logout() {
        this.user = {
            ...this.user,
            azureId: '',
            token: '',
            isAdmin: false,
            email: '',
        };
        this.updateUser(this.user);
    }

    updateUser(newUserData: Partial<User>) {
        this.user = Object.assign(this.user, newUserData) as User;
        localStorage.setItem('user', JSON.stringify(this.user));
    }

    isLoggedIn(): boolean {
        return !!this.user.token;
    }
}
